export class UnitFilterModel {
    public facilityId: number;
    public status: string;
    public filterKey: string;

    constructor() {
        this.status = '';
    }
}
